import productUtils from '@/core/productUtils'
const state = {
  // 材料品类
  categories: [],
  // 品类下的所有属性
  categoryProperties: [],
  // 品类下的聚合数量
  categoryAgg: [],
  // 列表数据
  listData: [],
  tableLoading: false,
  totalCount: 0,
}
const getters = {
  categories: (state) => state.categories,
  categoriesWithCount: (state) => {
    return state.categories.map((c) => {
      const countObj = state.categoryAgg.find((ca) => ca.gjwCategoryCode === c.code) || {}
      // 字段名是为了配合平铺分类组件使用
      return {
        categoryId: c.code,
        categoryName: c.name,
        categoryTotal: countObj.count,
      }
    })
  },
  // 动态搜索的属性
  searchProperties: (state) => {
    // 目前仅处理了dataType为Enum枚举的情况，如果需要支持其他类型，要根据产品需求，另外进行开发，接口也暂不支持非枚举值的搜索
    const res = []
    const searchProps = productUtils.getAllPropertiesByCode(state.categoryProperties, 'isSearch', (value) => value === 'true')
    searchProps.forEach((item) => {
      if (item.dataType === 'Enum') {
        item.values = item.enumValues
        res.push(item)
      }
    })
    return res
  },
  // 列表动态展示的属性
  tableCols: (state) => {
    const cols = []
    state.categoryProperties.forEach((prop) => {
      const colLabel = prop.unitSymbol ? `${prop.name} ${prop.unitSymbol}` : prop.name
      cols.push(
        {
          label: colLabel,
          prop: prop.code,
        }
      )
    })
    return cols
  },
  tableData: (state) => {
    const res = []
    state.listData.forEach((row) => {
      const tableRow = { ...row }
      const materialPropertyValues = row.materialPropertyValues
      materialPropertyValues.forEach((item) => {
        tableRow[item.code] = item.value || '-'
      })
      res.push(tableRow)
    })
    return res
  },
  tableLoading: (state) => state.tableLoading,
  totalCount: (state) => state.totalCount,
  categoryProperties: (state) => state.categoryProperties
}
const mutations = {
  setCategories(state, data) {
    state.categories = data
  },
  setCategoryProperties(state, data) {
    state.categoryProperties = data
  },
  setCategoryAgg(state, data) {
    state.categoryAgg = data
  },
  setListData(state, data) {
    state.listData = data
  },
  setTotalCount(state, data) {
    state.totalCount = data
  },
  setTableLoading(state, bool) {
    state.tableLoading = bool
  },

}
const actions = {
  async loadListData({ commit }, payload) {
    commit('setTableLoading', true)
    try {
      const { list, totalCount } = await this.$api.material.list(payload)
      commit('setListData', list || [])
      commit('setTotalCount', totalCount || 0)
    } catch (error) {
      commit('setListData', [])
      commit('setTotalCount', 0)
      console.error(error)
    } finally {
      commit('setTableLoading', false)
    }
  },
  async loadCategories({ commit }) {
    try {
      const data = await this.$api.material.getCategories()
      commit('setCategories', data || [])
    } catch (error) {
      commit('setCategories', [])
      console.error(error)
    }
  },
  async loadCategoryProperties({ commit }, payload = {}) {
    try {
      const classification_code = payload.gjwCategoryCode
      delete payload.gjwCategoryCode
      payload.resourceType = 'STANDARD_MATERIAL'
      const data = await this.$api.classification.getClassificationProperties(classification_code, payload)
      commit('setCategoryProperties', data || [])
    } catch (error) {
      commit('setCategoryProperties', [])
      console.error(error)
    }
  },
  // 所有品类的数据聚合
  async loadCategoryAgg({ commit }) {
    try {
      const data = await this.$api.material.getCategoryAgg()
      commit('setCategoryAgg', data || [])
    } catch (error) {
      commit('setCategoryAgg', [])
      console.error(error)
    }
  },

}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
